/**
 * 用于传播事件
 */
import Vue from 'vue';

export const VueBus = new Vue();
